'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'narwhal';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f6fe';
var svgPathData = 'M594.39 224.44l44.9-191.9c2.72-11.5-2.59-23.5-13-29.25-6.19-3.37-13.38-4.22-20.19-2.22-6.78 1.98-12.41 6.48-15.75 12.62l-99.19 179.69C296.64 207.72 223.11 416 179.87 416c-10.96 0-19.87-8.92-19.87-19.88V288l47.37-24.9c10.39-5.93 16.62-15.93 16.62-26.62v-92.45c0-9.41-9.01-16.03-18.72-16.03-3.47 0-7.03.85-10.3 2.71L112 178.13l-82.98-47.42c-3.27-1.87-6.83-2.71-10.3-2.71C9.01 128 0 134.61 0 144.03v92.45c0 10.7 6.24 20.69 16.62 26.62L64 288v108.12c0 64 51.88 115.87 115.87 115.87H560c44.18 0 80-35.82 80-80V320.54c0-39.11-18.68-72.86-45.61-96.1zm4.65-160.26l-33.11 141.37c-12.23-6.06-25.11-10.06-38.37-11.9l71.48-129.47zM608 432c0 26.47-21.53 48-48 48H179.87C133.63 480 96 442.37 96 396.13V268.67l-64-33.84v-65.56l80 45.71 80-45.71v65.76l-64 33.64v127.46c0 28.6 23.27 51.87 51.87 51.87 29.8 0 49.95-25.95 80.45-65.23C309.41 319.55 383.6 224 512 224c45.41 0 96 39.65 96 96.54V432zm-176-80c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faNarwhal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;